export const CHANNEL_TAG_AUTOMATION_OBJECT_TYPES = {
  CONTACT: "Contacts",
  INSTANCE: "Meetings",
};

export const TAG_PROPS = {
  MAX_CHAR_PER_ROW: 40,
  MAX_NUM_ROWS: 2,
};
